import React from 'react';
import Icon from 'components/AppIcon';

export default function MobileControls({ onLeft, onRight, onJump, onSlide }) {
  return (
    <div className="flex items-center justify-between px-4 py-3 md:hidden">
      {/* Left/Right */}
      <div className="flex gap-3">
        <button
          onTouchStart={(e) => { e?.preventDefault(); onLeft?.(); }}
          onMouseDown={onLeft}
          className="w-16 h-16 rounded-2xl flex items-center justify-center select-none active:scale-90 transition-transform"
          style={{ background: 'rgba(99,102,241,0.4)', border: '2px solid rgba(129,140,248,0.6)' }}
          aria-label="Move left"
        >
          <Icon name="ChevronLeft" size={28} color="white" />
        </button>
        <button
          onTouchStart={(e) => { e?.preventDefault(); onRight?.(); }}
          onMouseDown={onRight}
          className="w-16 h-16 rounded-2xl flex items-center justify-center select-none active:scale-90 transition-transform"
          style={{ background: 'rgba(99,102,241,0.4)', border: '2px solid rgba(129,140,248,0.6)' }}
          aria-label="Move right"
        >
          <Icon name="ChevronRight" size={28} color="white" />
        </button>
      </div>
      {/* Jump + Slide */}
      <div className="flex gap-3">
        <button
          onTouchStart={(e) => { e?.preventDefault(); onSlide?.(); }}
          onMouseDown={onSlide}
          className="w-16 h-16 rounded-2xl flex items-center justify-center select-none active:scale-90 transition-transform"
          style={{ background: 'rgba(239,68,68,0.4)', border: '2px solid rgba(248,113,113,0.6)' }}
          aria-label="Slide"
        >
          <Icon name="ChevronDown" size={28} color="white" />
        </button>
        <button
          onTouchStart={(e) => { e?.preventDefault(); onJump?.(); }}
          onMouseDown={onJump}
          className="w-16 h-16 rounded-2xl flex items-center justify-center select-none active:scale-90 transition-transform"
          style={{ background: 'rgba(16,185,129,0.5)', border: '2px solid rgba(52,211,153,0.7)' }}
          aria-label="Jump"
        >
          <Icon name="ChevronUp" size={28} color="white" />
        </button>
      </div>
    </div>
  );
}
